module.exports = __webpack_public_path__ + "img/u420.4efe0139.png";